export default __webpack_public_path__ + "static/media/toydummerboy.13daf94f.png";